import React from "react"
import { useIntl } from "react-intl"
import { collapseSideBar } from "context/applicationContext"
import "./index.scss"
import { Card } from "./Shared/card"
import {
	CardType,
	CHANNELS_COLORS,
	AGE_COLORS,
	GENDER_COLORS,
} from "./Shared/constants"
import { CustomerSegmentationResponse } from "../Shared/interfaces"
import { validateValuePercentage } from "../utils"

export interface CustomerSegmentationProps {
	descriptionCustomerSegmentation: CustomerSegmentationResponse
}

const CustomerSegmentation: React.FC<CustomerSegmentationProps> = ({
	descriptionCustomerSegmentation,
}) => {
	collapseSideBar()
	const intl = useIntl()

	const renderCustomersInfo = () => {
		return intl.formatMessage(
			{
				id: validateValuePercentage(
					descriptionCustomerSegmentation.customerInformation
						?.percentageSalesByCustomers,
					"phronesis.transactional.application.growth-profiling.customer-segmentation.customers-info",
					"phronesis.transactional.application.growth-profiling.customer-segmentation.customers-info.lessThanOne"
				),
			},
			{
				customersPercentage: intl.formatNumber(
					descriptionCustomerSegmentation.customerInformation
						?.percentageSalesByCustomers,
					{
						style: "percent",
						minimumFractionDigits: 1,
					}
				),
				customersQuantity: intl.formatNumber(
					descriptionCustomerSegmentation.customerInformation?.totalCustomers
				),
				b: (str) => <b>{str}</b>,
			}
		)
	}

	return (
		<div role="customer-segmentation" className="customer-segmentation">
			<div className="submodule-header">
				<div className="submodule-title  font-24 bold">
					{intl.formatMessage({
						id:
							"phronesis.transactional.application.growth-profiling.customer-segmentation.title",
					})}
				</div>
			</div>
			<div className="customers-info-message">{renderCustomersInfo()}</div>
			<div>
				<div className="insights-container">
					<div className="insight-container">
						<Card
							title={intl.formatMessage({
								id:
									"phronesis.transactional.application.growth-profiling.customer-segmentation.age",
							})}
							description={intl.formatMessage({
								id:
									"phronesis.transactional.application.growth-profiling.customer-segmentation.age.description",
							})}
							data={descriptionCustomerSegmentation.age ?? []}
							cardType={CardType.HORIZONTAL_BAR_CHART}
							colorPalette={AGE_COLORS}
						/>
					</div>
					<div className="insight-container">
						<Card
							title={intl.formatMessage({
								id:
									"phronesis.transactional.application.growth-profiling.customer-segmentation.gender",
							})}
							description={intl.formatMessage({
								id:
									"phronesis.transactional.application.growth-profiling.customer-segmentation.gender.description",
							})}
							data={descriptionCustomerSegmentation.gender}
							cardType={CardType.HORIZONTAL_BAR_CHART}
							colorPalette={GENDER_COLORS}
						/>
					</div>
					<div className="insight-container">
						<Card
							title={intl.formatMessage({
								id:
									"phronesis.transactional.application.growth-profiling.customer-segmentation.channels-use",
							})}
							description={intl.formatMessage({
								id:
									"phronesis.transactional.application.growth-profiling.customer-segmentation.channels-use.description",
							})}
							data={descriptionCustomerSegmentation.channels ?? []}
							cardType={CardType.PIE_CHART}
							colorPalette={CHANNELS_COLORS}
						/>
					</div>
				</div>
			</div>
		</div>
	)
}

export default CustomerSegmentation
